import React, { useState, useEffect } from 'react';
import Dashboard from './Dashboard';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import * as api from '../../services/apis';
import { useKeycloak } from '../../hooks/useKeycloak';

const DashBoardContainer = () => {
  const history = useNavigate();
  const { t, i18n } = useTranslation();
  const [statistics, setStatistics] = useState({
    certifications: {
      certificateValid: 0,
      certificateRevoked: 0,
      certificateExpired: 0,
    },
    clearance: {
      warringInvoicesCount: 0,
      passedInvoicesCount: 0,
      errorInvoicesCount: 0,
    },
    reporting: {
      warringInvoicesCount: 0,
      passedInvoicesCount: 0,
      errorInvoicesCount: 0,
    },
  });
  const [loading, setLoading] = useState(true);

  const { logout, userInfo } = useKeycloak();

  useEffect(() => {
    if (userInfo) {
      api
        .getStatistics(userInfo.tax_number)
        .then((resp) => {
          console.log({ resp });

          setStatistics(resp.data);
          setLoading(false);
        })
        .catch((err) => {
          console.log({ err });

          if (err?.status === 401) {
            logout();
          }
        });
    }
  }, [userInfo]);

  const handleHomeClick = () => {
    history(`/${i18n.language}`, { replace: true });
  };

  return (
    <Dashboard
      loading={loading}
      onHomeClick={handleHomeClick}
      t={t}
      values={statistics}
    />
  );
};

export default React.memo(DashBoardContainer);
